import CustomUpdatedPopUpModal from '../../mobilecomponents/eir-porting/CustomModal/CustomUpdatedPopUpModal';
import { Box, Typography, Button } from '@material-ui/core';
import sadsmily from '../../mobilecomponents/images/sad.png';
import useStyle from '../../mobilecomponents/eir-porting/CustomModal/style';
import { useState } from 'react';
import React from 'react';
import EirButton from '../../theme/EirButton';

const MyEirRegistrationErrorsPopup = props => {
    const [openPopup, setOpenPopup] = useState(props.open);
    const [cta1, setCTA1] = useState({ text: '', action: () => {}, disable: false });
    const [cta2, setCTA2] = useState({ text: '', action: () => {}, disable: false });
    const styles = useStyle();

    const handleCloseError = async () => {
        setOpenPopup(false);
        props.setOpen(false);
    };

    return (
        <Box className='errorHandle' maxWidth='md'>
            <CustomUpdatedPopUpModal
                cssId='myeir-modal-window-error'
                open={openPopup}
                cta1={cta1}
                cta2={cta2}
                toggle={handleCloseError}
            >
                <Typography className={styles.imgText}>{props.headText}</Typography>
                <Box className={styles.imgcontent}>
                    <Box component='img' src={sadsmily} alt='sad-smily' className={styles.sadImg} />
                </Box>
                <Box>
                    <Typography className={styles.sadText}>{props.subText}</Typography>
                    <EirButton
                        style={{
                            width: '7.125rem',
                            display: 'flex',
                            justifyContent: 'center',
                            margin: '0 auto',
                            flexFlow: 'column',
                            alignItems: 'center',
                        }}
                        variants='primaryButtonMedium'
                        // className={styles.cancelBtn}
                        onClick={handleCloseError}
                    >
                        Close
                    </EirButton>
                </Box>
            </CustomUpdatedPopUpModal>
        </Box>
    );
};

export default MyEirRegistrationErrorsPopup;
